import { createFileRoute } from "@tanstack/react-router";
import { Header } from "@/components/site/Header";
import { RealizacieGallery } from "@/components/site/RealizacieGallery";
import { Footer } from "@/components/site/Footer";

export const Route = createFileRoute("/realizacia")({
  head: () => ({
    meta: [
      { title: "Naše realizácie — ARTBAZ | Rekonštrukcie a stavby Trenčín" },
      {
        name: "description",
        content:
          "Portfólio realizácií ARTBAZ — rekonštrukcie kúpeľní, kuchýň, bytov, stavby a interiéry. Viac ako 300 dokončených projektov a 8 rokov skúseností.",
      },
      { property: "og:title", content: "Naše realizácie — ARTBAZ" },
      {
        property: "og:description",
        content:
          "Výber realizácií, ktoré sme úspešne dokončili pre našich klientov — kúpeľne, kuchyne, byty, stavby a interiéry.",
      },
    ],
  }),
  component: RealizaciaPage,
});

function RealizaciaPage() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-28">
        <RealizacieGallery />
      </main>
      <Footer />
    </div>
  );
}
